import React from 'react'

import { Button, ButtonClean, useMediaQueryContext } from '@fourthwall/components'
import { SubscriptionBadge } from '@modules/Dashboard/modules/Subscriptions'
import { routing } from '@utils/routing'

import type { DomainStatus } from '../../CustomDomain.types'
import { DomainStatusTag } from '../DomainStatusTag/DomainStatusTag'
import * as S from './DomainTile.styled'

type PaidDomainTileProps = {
  domainName: string
  status: DomainStatus
  showSubscriptionBadge?: boolean
  showViewDnsButton?: boolean
  isConnecting: boolean
  isRetrying: boolean
  removeDomainLabel?: string
  onDomainDelete?: () => void
  onDomainConnect?: () => void
  onRetryConnection?: () => void
}

export const DomainTile = ({
  domainName,
  status,
  showSubscriptionBadge = false,
  showViewDnsButton = false,
  isConnecting,
  isRetrying,
  removeDomainLabel = 'Remove domain',
  onDomainDelete,
  onDomainConnect,
  onRetryConnection,
}: PaidDomainTileProps) => {
  const media = useMediaQueryContext()

  return (
    <S.Container>
      {showSubscriptionBadge && (
        <SubscriptionBadge
          label={
            <>
              <s>$24/year</s> Free with your Fourthwall Pro
            </>
          }
        />
      )}
      <S.DomainName>
        <div>{domainName}</div>
        <DomainStatusTag status={status} />
      </S.DomainName>

      <S.ConnectedButtonsWrapper>
        {status === 'NOT_CONNECTED' && onDomainConnect && (
          <Button
            label="Connect this domain"
            appearance="primary"
            size="small"
            fullWidth={!media.tablet}
            loading={isConnecting}
            onClick={onDomainConnect}
          />
        )}
        {onRetryConnection && (
          <Button
            appearance="primary"
            label="Retry connection"
            size="small"
            fullWidth={!media.tablet}
            loading={isRetrying}
            onClick={onRetryConnection}
          />
        )}
        {showViewDnsButton && (
          <ButtonClean label="View DNS records" to={routing.settings.domain.configuration} />
        )}
        {onDomainDelete && <ButtonClean label={removeDomainLabel} onClick={onDomainDelete} />}
      </S.ConnectedButtonsWrapper>

      {status === 'SYNCING_YOUR_DOMAIN' ||
        (status === 'CONNECTING' && (
          <div>Your domain is being connected. This process can last up to 24 hours.</div>
        ))}
      {status === 'REMOVAL_IN_PROGRESS' && (
        <div>Removal process usually takes a couple of seconds.</div>
      )}
    </S.Container>
  )
}
